<template>
  <div>
    <div class="time">
      <div>
        {{ $l.eventTime }}
      </div>

      <div>
        {{ playingTime }}
      </div>
    </div>

    <div class="time">
      <div>
        {{ $l.answerTime }}
      </div>

      <div>
        {{ answerTime }}
      </div>
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    playingTime: function () {
      const time = this.$store.getters['event/playingTime']
      return time.start + ' ~ ' + time.end
    },

    answerTime: function () {
      const time = this.$store.getters['event/answerTime']
      return time.start + ' ~ ' + time.end
    }
  }
}
</script>

<style lang="scss" scoped>
.time {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}
</style>
